// src/components/Booking/CancelBookingModal.jsx
import React from "react";
import { Modal, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelBookingByRecp,
  fetchBookingByRecp,
} from "../../Redux/Slice/Patient/Booking";
import { toast } from "react-toastify";

const CancelBookingModal = ({
  open,
  onClose,
  booking,
  branchId,
  handleSearch,
  isSearchActive,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.booking?.cancelData);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        appointmentId: booking.appointmentId,
        cancellationReason: values.reason,
      };

      // Dispatch the cancel API and unwrap the result
      const res = await dispatch(cancelBookingByRecp(payload)).unwrap();

      // Show success message from API response
      toast.success(res?.message || "Booking cancelled successfully!");

      // Refresh the booking list

      if (isSearchActive) {
        handleSearch();
      } else {
        dispatch(fetchBookingByRecp({ branchId }));
      }

      // Close modal
      onClose();
    } catch (error) {
      // Handle validation or API errors
      toast.error(error?.message || "Something went wrong while cancelling!");
    }
  };

  return (
    <Modal
      title="Cancel Booking"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Cancel Booking"
      okButtonProps={{ danger: true }}
      confirmLoading={loading}
    >
      <p>
        Are you sure you want to cancel the booking for{" "}
        <b>{booking?.patient?.name}</b>?
      </p>
      <Form layout="vertical" form={form}>
        <Form.Item
          name="reason"
          label="Reason for Cancellation"
          rules={[{ required: true, message: "Please provide a reason" }]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CancelBookingModal;
